export const subTotal = (id, price) => {
  let subTotalCost = 0;
  let carts;
  try {
    carts = JSON.parse(localStorage.getItem("cart") || "[]");
  } catch (e) {
    carts = [];
  }
  if (!Array.isArray(carts)) carts = [];
  carts.forEach((item) => {
    if (item.id === id) {
      subTotalCost = (item.quantity || 0) * (price || 0);
    }
  });
  return subTotalCost;
};

export const quantity = (id) => {
  let product = 0;
  let carts;
  try {
    carts = JSON.parse(localStorage.getItem("cart") || "[]");
  } catch (e) {
    carts = [];
  }
  if (!Array.isArray(carts)) carts = [];
  carts.forEach((item) => {
    if (item.id === id) {
      product = item.quantity || 0;
    }
  });
  return product;
};

export const totalCost = () => {
  let total = 0;
  let carts;
  try {
    carts = JSON.parse(localStorage.getItem("cart") || "[]");
  } catch (e) {
    carts = [];
  }
  if (!Array.isArray(carts)) carts = [];
  carts.forEach((item) => {
    const qty = Number(item.quantity) || 0;
    const price = Number(item.price) || 0;
    total += qty * price;
  });
  return total;
};
